import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import SectionContainer from "@project/templates/home/SectionContainer";
import SectionHeader from "@project/templates/home/SectionHeader";
import theme from "@project/theme/theme";
import DynamicContainer from "@project/templates/home/DynamicContainer";
const ThreatsPart = (props) => {
    const { page } = props;
    const { contents } = page || {};
    const { titleThreatsPart, subtitleThreatsPart, descriptionThreatsPart, dynamicThreatsStatsPart, sourcesThreatsPart, dynamicThreatsPart, } = contents;
    return (_jsxs(SectionContainer, { backgroundColor: theme.palette.background.dark, hasDarkBackground: true, children: [_jsx(SectionHeader, { surtitle: titleThreatsPart, title: subtitleThreatsPart, description: descriptionThreatsPart, contrast: true }), _jsxs(Stack, { spacing: 3, children: [_jsxs(Stack, { spacing: 2, children: [_jsx(DynamicContainer, { spacing: 0, children: dynamicThreatsStatsPart }), sourcesThreatsPart && (_jsx(Typography, { variant: "caption", sx: { color: "primary.contrastText" }, children: sourcesThreatsPart }))] }), _jsx(DynamicContainer, { children: dynamicThreatsPart })] })] }));
};
export default ThreatsPart;
